import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationPickerComponent } from './location-picker.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [LocationPickerComponent],
  imports: [CommonModule, BrowserAnimationsModule],
  exports: [LocationPickerComponent],
})
export class LocationPickerModule {}
